import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 400 },
    threshold: { type: Number, default: 3 },
  }

  connect() {
    this.timeout = null;
    this.restoreCaret();
  }

  disconnect() {
    this.cancel();
  }

  search() {
    this.cancel();

    const term = this.element.value.trim();

    if (term.length > 0 && term.length < this.thresholdValue) return;

    this.timeout = setTimeout(() => this.element.form.requestSubmit(), this.delayValue);
  }

  cancel() {
    if (!this.timeout) return;

    clearTimeout(this.timeout);
    this.timeout = null;
  }

  restoreCaret() {
    if (!this.element.value) return;

    const { length } = this.element.value;

    this.element.focus();
    this.element.setSelectionRange(length, length);
  }
}
